import { computed, type Ref } from 'vue';
import { formatDateToDDMMYYYY } from '@tools/dates';
import { useRelatiesGetRelationByRelatienummer } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import { useWatchErrorHandler } from '@errors/useErrorHandler';

export function useRoydataLink(relatienummer: Ref<number | null | undefined>) {
  const { data: relatiegegevens, error: relatieError } = useRelatiesGetRelationByRelatienummer(
    relatienummer,
    { query: { select: (e) => e.result } },
  );
  useWatchErrorHandler(relatieError);

  return computed(() => {
    if (!relatiegegevens.value) {
      return undefined;
    }

    const roydataUrl = new URL('https://roydata.stichting-eps.nl/bevraging-aanmaken');
    roydataUrl.searchParams.set('subjecttype', 'O');

    if (relatiegegevens.value?.name) {
      roydataUrl.searchParams.set('naam', relatiegegevens.value?.name);
    }

    if (relatiegegevens.value?.adres?.postcode) {
      roydataUrl.searchParams.set(
        'postcode',
        relatiegegevens.value?.adres?.postcode.replace(' ', ''),
      );
    }

    if (relatiegegevens.value?.adres?.huisnummer) {
      roydataUrl.searchParams.set(
        'huisnummer',
        relatiegegevens.value?.adres?.huisnummer.toString(),
      );
    }

    if (relatiegegevens.value?.adres?.huisnummertoevoeging) {
      roydataUrl.searchParams.set('toevoeging', relatiegegevens.value?.adres?.huisnummertoevoeging);
    }

    if (relatiegegevens.value?.typeName === 'P') {
      if (relatiegegevens.value?.voorletters) {
        roydataUrl.searchParams.set(
          'voorletter',
          relatiegegevens.value?.voorletters.replace(/[.\s]/g, ''),
        );
      }

      if (relatiegegevens.value?.tussenvoegsels) {
        roydataUrl.searchParams.set('tussenvoegsel', relatiegegevens.value?.tussenvoegsels);
      }

      if (relatiegegevens.value?.geboortedatum) {
        roydataUrl.searchParams.set(
          'geboortedatum',
          formatDateToDDMMYYYY(relatiegegevens.value?.geboortedatum),
        );
      }
    }

    return {
      label: 'Roydata',
      icon: 'far fa-car',
      url: roydataUrl.toString(),
      target: '_blank',
    };
  });
}
